// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "html.full-height,html.full-height body{height:100%}html.full-height #__layout,html.full-height #__nuxt,html.full-height #app,html.full-height #app>.v-application--wrap,html.full-height .v-main,html.full-height .v-main__wrap{height:100%}", ""]);
// Exports
module.exports = exports;
